(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-blog-post"]) return;
  try {
    
  (() => {
    const headerControllerKey = '__cgauCrimeClockHeaderController';
    const heroControllerKey = '__cgauCrimeClockHeroMorph';
    const statsControllerKey = '__cgauCrimeClockStats';
    const markerSelector = '[data-cgau-crime-clock-controller]';

    const getScrollPosition = (pageWrapper) => Math.max(
      window.scrollY,
      document.scrollingElement?.scrollTop || 0,
      pageWrapper?.scrollTop || 0
    );

    const initialiseHeroMorph = () => {
      if (typeof window[heroControllerKey] === 'function') {
        window[heroControllerKey]();
      }

      const source = document.querySelector('.cgau-crime-clock > .cc-hero');
      const pageWrapper = document.querySelector('.page-wrapper');
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

      if (!source || reducedMotion.matches || location.hash || getScrollPosition(pageWrapper) > 8) return;

      const flight = document.createElement('div');
      const visual = source.cloneNode(true);

      flight.className = 'cgau-crime-clock cc-hero-flight';
      flight.setAttribute('aria-hidden', 'true');
      visual.removeAttribute('id');
      visual.querySelectorAll('[id]').forEach((node) => node.removeAttribute('id'));
      flight.appendChild(visual);
      document.body.appendChild(flight);
      source.classList.add('cc-hero-flight-source');

      const scrollTargets = pageWrapper ? [window, pageWrapper] : [window];
      const visualTitle = visual.querySelector('.cc-display-title');
      const sourceTitle = source.querySelector('.cc-display-title');
      const visualKicker = visual.querySelector('.cc-kicker');
      const sourceTitleStyle = sourceTitle?.getAttribute('style') || null;
      const sourceTitleAriaHidden = sourceTitle?.getAttribute('aria-hidden') || null;
      let titlePlaceholder = null;
      let titleLayer = null;
      let active = true;
      let frame = 0;
      let landing = false;
      let settleEnd = 1;
      let startScroll = 0;
      let measuredWidth = 0;
      let full = { left: 0, top: 0, width: 1, height: 1 };
      let target = { left: 0, top: 0, width: 1, height: 1 };
      let titleStart = { left: 0, top: 0, width: 1, height: 1 };
      let titleTarget = { left: 0, top: 0, width: 1, height: 1 };
      let opening = {
        copyLift: 0,
        kickerDrop: 0,
        sideShift: 0,
        clockBoost: 0,
        copyBoost: 0,
        wide: false
      };

      /* Keep the real headline as the only visible headline. A hidden clone holds
         its grid slot while the original travels in a fixed compositor layer, then
         the original node is put back into that exact slot at landing. */
      if (sourceTitle && visualTitle) {
        titlePlaceholder = sourceTitle.cloneNode(true);
        titlePlaceholder.removeAttribute('id');
        titlePlaceholder.style.visibility = 'hidden';
        sourceTitle.replaceWith(titlePlaceholder);
        sourceTitle.setAttribute('aria-hidden', 'true');

        titleLayer = document.createElement('div');
        titleLayer.setAttribute('aria-hidden', 'true');
        Object.assign(titleLayer.style, {
          position: 'fixed',
          zIndex: '5',
          inset: '0',
          overflow: 'visible',
          pointerEvents: 'none',
          opacity: '0'
        });
        titleLayer.appendChild(sourceTitle);
        document.body.appendChild(titleLayer);
      }

      const getViewportRect = () => ({
        left: 0,
        top: 0,
        width: document.documentElement.clientWidth,
        height: window.innerHeight
      });

      /* All geometry is read once at rest. Scroll frames then touch only
         transform, opacity and CSS variables, avoiding layout feedback. */
      const measure = () => {
        if (!active) return;

        const scroll = getScrollPosition(pageWrapper);
        const rect = source.getBoundingClientRect();
        const headerBottom = Math.max(
          0,
          ...Array.from(document.querySelectorAll('.shopify-section-group-header-group'))
            .map((header) => header.getBoundingClientRect().bottom)
        );

        full = getViewportRect();
        target = {
          left: rect.left,
          top: rect.top,
          width: rect.width,
          height: rect.height
        };
        startScroll = scroll;
        measuredWidth = full.width;
        settleEnd = Math.max(startScroll + 180, startScroll + rect.top - 8);

        flight.style.left = `${full.left}px`;
        flight.style.top = `${full.top}px`;
        flight.style.width = `${full.width}px`;
        flight.style.height = `${full.height}px`;
        flight.style.transform = 'translate3d(0, 0, 0) scale(1)';

        const wide = full.width >= 900;
        opening = {
          copyLift: wide && visualTitle
            ? Math.max(0, visualTitle.offsetTop - (full.height * 0.26))
            : 0,
          kickerDrop: visualKicker
            ? Math.max(0, headerBottom + 16 - visualKicker.offsetTop)
            : 0,
          sideShift: wide ? Math.min(68, full.width * 0.04) : 0,
          clockBoost: wide ? 0.36 : 0,
          copyBoost: wide ? 0.2 : 0,
          wide
        };

        if (sourceTitle && visualTitle && titlePlaceholder && titleLayer) {
          flight.style.setProperty('--cc-flight-copy-lift', `${opening.copyLift}px`);
          flight.style.setProperty('--cc-flight-kicker-drop', `${opening.kickerDrop}px`);
          flight.style.setProperty('--cc-flight-content-drop', `${opening.wide ? 0 : opening.kickerDrop}px`);
          flight.style.setProperty('--cc-flight-side-shift', `${opening.sideShift}px`);
          flight.style.setProperty('--cc-flight-clock-scale', String(1 + opening.clockBoost));
          flight.style.setProperty('--cc-flight-copy-scale', String(1 + opening.copyBoost));

          const placeholderRect = titlePlaceholder.getBoundingClientRect();
          const openingRect = visualTitle.getBoundingClientRect();
          const titleStyle = window.getComputedStyle(titlePlaceholder);

          titleTarget = {
            left: placeholderRect.left,
            top: placeholderRect.top,
            width: Math.max(1, placeholderRect.width),
            height: Math.max(1, placeholderRect.height)
          };
          titleStart = {
            left: openingRect.left,
            top: openingRect.top,
            width: Math.max(1, openingRect.width),
            height: Math.max(1, openingRect.height)
          };

          Object.assign(sourceTitle.style, {
            position: 'absolute',
            left: `${titleTarget.left}px`,
            top: `${titleTarget.top}px`,
            width: `${titleTarget.width}px`,
            maxWidth: 'none',
            margin: '0',
            padding: '0',
            boxSizing: 'border-box',
            color: titleStyle.color,
            fontFamily: titleStyle.fontFamily,
            fontSize: titleStyle.fontSize,
            fontStyle: titleStyle.fontStyle,
            fontWeight: titleStyle.fontWeight,
            lineHeight: titleStyle.lineHeight,
            letterSpacing: titleStyle.letterSpacing,
            textAlign: titleStyle.textAlign,
            textTransform: titleStyle.textTransform,
            whiteSpace: titleStyle.whiteSpace,
            transformOrigin: '0 0',
            willChange: 'transform'
          });
          sourceTitle.style.setProperty('text-wrap', titleStyle.getPropertyValue('text-wrap'));
          sourceTitle.style.setProperty('overflow-wrap', titleStyle.getPropertyValue('overflow-wrap'));
          visualTitle.style.visibility = 'hidden';
          titleLayer.style.opacity = '1';
        }
      };

      const paint = () => {
        frame = 0;
        if (!active) return;

        const scroll = getScrollPosition(pageWrapper);
        const distance = Math.max(1, settleEnd - startScroll);
        const raw = Math.min(1, Math.max(0, (scroll - startScroll) / distance));

        source.classList.add('cc-hero-flight-source');
        flight.hidden = false;

        const progress = raw * raw * (3 - (2 * raw));
        const inverse = 1 - progress;
        const mix = (from, to) => from + ((to - from) * progress);
        const targetTop = target.top - (scroll - startScroll);
        const translateX = mix(0, target.left - full.left);
        const translateY = mix(0, targetTop - full.top);
        const scaleX = mix(1, target.width / full.width);
        const scaleY = mix(1, target.height / full.height);
        flight.style.transform = `translate3d(${translateX}px, ${translateY}px, 0) scale(${scaleX}, ${scaleY})`;
        flight.style.opacity = '1';
        source.style.opacity = '0';
        flight.style.setProperty('--cc-flight-copy-lift', `${opening.copyLift * inverse}px`);
        flight.style.setProperty('--cc-flight-kicker-drop', `${opening.kickerDrop * inverse}px`);
        flight.style.setProperty(
          '--cc-flight-content-drop',
          `${opening.wide ? 0 : opening.kickerDrop * inverse}px`
        );
        flight.style.setProperty('--cc-flight-side-shift', `${opening.sideShift * inverse}px`);
        flight.style.setProperty('--cc-flight-clock-scale', String(1 + (opening.clockBoost * inverse)));
        flight.style.setProperty('--cc-flight-copy-scale', String(1 + (opening.copyBoost * inverse)));

        if (sourceTitle && titleLayer) {
          const scrollDelta = scroll - startScroll;
          const titleLeft = mix(titleStart.left, titleTarget.left);
          const titleTop = mix(titleStart.top, titleTarget.top - scrollDelta);
          const titleScaleX = mix(titleStart.width / titleTarget.width, 1);
          const titleScaleY = mix(titleStart.height / titleTarget.height, 1);
          sourceTitle.style.transform = `translate3d(${titleLeft - titleTarget.left}px, ${titleTop - titleTarget.top}px, 0) scale(${titleScaleX}, ${titleScaleY})`;
        }

        /* Paint one exact destination frame before replacing the placeholder.
           This prevents a scroll event and cleanup from collapsing into the same
           frame and makes the real headline's handoff visually continuous. */
        if (raw >= 1 && !landing) {
          landing = true;
          frame = window.requestAnimationFrame(cleanup);
        }
      };

      const schedule = () => {
        if (!frame) frame = window.requestAnimationFrame(paint);
      };

      const cleanup = () => {
        frame = 0;
        active = false;
        scrollTargets.forEach((target) => target.removeEventListener('scroll', schedule));
        window.removeEventListener('resize', remeasureOnResize);
        window.removeEventListener('pageshow', handlePageShow);
        window.removeEventListener('load', refreshAtTop);
        reducedMotion.removeEventListener('change', onMotionChange);
        if (titlePlaceholder?.isConnected && sourceTitle) {
          titlePlaceholder.replaceWith(sourceTitle);
        }
        if (sourceTitle) {
          if (sourceTitleStyle === null) sourceTitle.removeAttribute('style');
          else sourceTitle.setAttribute('style', sourceTitleStyle);
          if (sourceTitleAriaHidden === null) sourceTitle.removeAttribute('aria-hidden');
          else sourceTitle.setAttribute('aria-hidden', sourceTitleAriaHidden);
        }
        titleLayer?.remove();
        source.classList.remove('cc-hero-flight-source');
        source.style.removeProperty('opacity');
        flight.remove();
        delete window[heroControllerKey];
      };

      const refreshAtTop = () => {
        if (!active) return;
        if (getScrollPosition(pageWrapper) > 8) {
          cleanup();
          return;
        }
        measure();
        schedule();
      };

      const remeasureOnResize = () => {
        const nextWidth = document.documentElement.clientWidth;
        if (Math.abs(nextWidth - measuredWidth) < 2) return;
        refreshAtTop();
      };

      const handlePageShow = () => refreshAtTop();

      const onMotionChange = () => {
        if (reducedMotion.matches) cleanup();
      };

      scrollTargets.forEach((target) => target.addEventListener('scroll', schedule, { passive: true }));
      window.addEventListener('resize', remeasureOnResize, { passive: true });
      window.addEventListener('pageshow', handlePageShow);
      window.addEventListener('load', refreshAtTop, { once: true });
      reducedMotion.addEventListener('change', onMotionChange);
      document.fonts?.ready.then(refreshAtTop);

      window[heroControllerKey] = cleanup;
      measure();
      paint();
    };

    const initialiseStats = () => {
      if (typeof window[statsControllerKey] === 'function') {
        window[statsControllerKey]();
      }

      const article = document.querySelector('.cgau-crime-clock');
      const pageWrapper = document.querySelector('.page-wrapper');
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      const desktopScroller = window.matchMedia('(min-width: 990px)');
      if (!article || reducedMotion.matches || !('IntersectionObserver' in window)) return;

      const counters = Array.from(article.querySelectorAll('[data-cc-count]')).map((element) => {
        const textNode = Array.from(element.childNodes).find(
          (node) => node.nodeType === Node.TEXT_NODE && /[\d,.]+/.test(node.nodeValue || '')
        );
        const target = Number(element.dataset.ccCount);
        if (!textNode || !Number.isFinite(target)) return null;

        const original = textNode.nodeValue;
        const token = original.match(/[\d,.]+/)?.[0];
        if (!token) return null;
        const decimalPart = String(element.dataset.ccCount).split('.')[1];
        const formatter = new Intl.NumberFormat('en-AU', {
          minimumFractionDigits: decimalPart?.length || 0,
          maximumFractionDigits: decimalPart?.length || 0
        });

        return {
          element,
          textNode,
          original,
          token,
          target,
          formatter,
          frame: 0,
          complete: false
        };
      }).filter(Boolean);

      if (!counters.length) return;

      const render = (counter, value) => {
        counter.textNode.nodeValue = counter.original.replace(counter.token, counter.formatter.format(value));
      };

      counters.forEach((counter) => render(counter, 0));

      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          const counter = counters.find((item) => item.element === entry.target);
          if (!counter || counter.complete) return;

          counter.complete = true;
          observer.unobserve(counter.element);
          const start = performance.now();
          const duration = Math.min(1450, Math.max(900, 780 + (Math.log10(counter.target + 1) * 135)));

          const tick = (now) => {
            const progress = Math.min(1, (now - start) / duration);
            const eased = 1 - Math.pow(1 - progress, 3);
            const decimals = String(counter.target).split('.')[1]?.length || 0;
            const factor = 10 ** decimals;
            render(counter, Math.round(counter.target * eased * factor) / factor);
            if (progress < 1) {
              counter.frame = window.requestAnimationFrame(tick);
            } else {
              render(counter, counter.target);
              counter.frame = 0;
            }
          };

          counter.frame = window.requestAnimationFrame(tick);
        });
      }, {
        root: desktopScroller.matches && pageWrapper ? pageWrapper : null,
        threshold: 0.3,
        rootMargin: '0px 0px -8% 0px'
      });

      counters.forEach((counter) => observer.observe(counter.element));

      const cleanup = () => {
        observer.disconnect();
        counters.forEach((counter) => {
          if (counter.frame) window.cancelAnimationFrame(counter.frame);
          counter.textNode.nodeValue = counter.original;
        });
        desktopScroller.removeEventListener('change', restart);
        reducedMotion.removeEventListener('change', restart);
        delete window[statsControllerKey];
      };

      const restart = () => {
        cleanup();
        initialiseStats();
      };

      desktopScroller.addEventListener('change', restart);
      reducedMotion.addEventListener('change', restart);
      window[statsControllerKey] = cleanup;
    };

    const initialise = () => {
      if (!document.querySelector(markerSelector)) return;

      if (typeof window[headerControllerKey] === 'function') {
        window[headerControllerKey]();
      }

      const root = document.documentElement;
      const attribute = 'data-cgau-crime-clock-away';
      const pageWrapper = document.querySelector('.page-wrapper');
      const scrollTargets = pageWrapper ? [window, pageWrapper] : [window];
      let frame = 0;

      const update = () => {
        frame = 0;
        const scrollPosition = getScrollPosition(pageWrapper);
        const isAway = root.getAttribute(attribute) === 'true';

        if (scrollPosition > 72 && !isAway) {
          root.setAttribute(attribute, 'true');
        } else if (scrollPosition <= 8 && isAway) {
          root.removeAttribute(attribute);
        }
      };

      const onScroll = () => {
        if (!frame) frame = window.requestAnimationFrame(update);
      };

      scrollTargets.forEach((target) => target.addEventListener('scroll', onScroll, { passive: true }));
      window.addEventListener('pageshow', update);
      update();

      window[headerControllerKey] = () => {
        scrollTargets.forEach((target) => target.removeEventListener('scroll', onScroll));
        window.removeEventListener('pageshow', update);
        if (frame) window.cancelAnimationFrame(frame);
        root.removeAttribute(attribute);
      };

      initialiseHeroMorph();
      initialiseStats();
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initialise, { once: true });
    } else {
      initialise();
    }

    document.addEventListener('shopify:section:load', initialise);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
